import React from 'react'
import styled from 'styled-components'
import { NormalContainer, Heading, Divider, MiniHeading } from '../global-styles'
import { ReactComponent as Logo } from '../assets/programming.svg'

export default function About() {
    return (
        <React.Fragment>
            <MainSection>
                <Logo />
                <BigText>
                    About Me
                </BigText>
            </MainSection>
            <Container>
                <IntroSection>
                    I'm Vinayak Singh, currently a pre-final year student at Indian Institute of Information Technology Ranchi. 
                    I specialise in Front End Development for web applications with a good experience of UI/UX designs with focus on simplicity and usability. 
                    I’m passionate about design and technology and how the two can converge to create experiences for good.
                </IntroSection>
                <IntroSection>
                    Also, I have experience of developing on WordPress.Currently, I am working on many projects, starting from a completely new blogging platform with an admin panel where I'll be writing and sharing my experiences with using the technologies I've worked upon. 
                    I've been learning Cybersecurity, Flutter App Development and my upcoming goals include complete fluency in Full Stack Web Development alongside Flutter App Development alongside using Javs for programming practically everything I can.
                </IntroSection>
                <IntroSection>
                    You can also find me working on my own projects on my <Social href={"https://github.com/vinayak-singh5302"}>Github</Social> Profile where I have uploaded self made projects and I am learning to incorporate more projects that can be used by a vast number of people. When I just began learning web development, my entire workbase was on <Social href={"https://codepen.io/vinayaksingh121"}>Codepen</Social> whih still includes some of my earliest works.
                </IntroSection>
                <Divider />
                <Education>
                    <MiniHeading>Education</MiniHeading>
                    <SchoolDetails>
                        <School>
                            <Name>Indian Institute of Information Technology Ranchi</Name>
                            <GradePoints>9.05 (/10.0) upto 5th Semester</GradePoints>
                        </School>
                        <School>
                            <Name>Guru Har Rai Academy, Kanpur</Name>
                            <GradePoints>97%</GradePoints>
                        </School>
                    </SchoolDetails>
                </Education>
            </Container>
        </React.Fragment>
    );
}

const Container = styled(NormalContainer)`
    margin: 50px auto;
`;

const MainSection = styled.div`
    display: flex;
    flex-flow: row wrap;
    align-items: flex-end;
    justify-content: center;
    align-items: center;
    margin-top: 5px;

    @media screen and(max-width: 991px){
        flex-flow: column wrap;
        align-items: center;
        justify-content: space-evenly;
    }
`;

const BigText = styled(Heading)`
    font-weight: 400;
    animation: fadeIn ease 3.5s infinite;

    @keyframes fadeIn{
    0% {
        color: #59d6ff;
    }
    20% {
        color: #82ff9c;
    }

    50% {
        color: #63FF83;
    }

    70% {
        color: #82ff9c;
    }
    100% {
        color: #59d6ff;
    }
    }
    
`;

const IntroSection = styled.p`
    color: #b1b1b1;
    margin-top: 50px;
    font-size: 16px;

    @media screen and(max-width: 991px){
        width: 100%;
        font-size: 14px;
    }
`;

const Social = styled.a`
    color: #fff;
    border-bottom: 1px solid #212121;
    font-weight: bold;

    &: hover {
        color: #5f27cd;
    }
`;

const Education = styled.div``;

const SchoolDetails = styled.div`
    display: flex;
    flex-direction: column;
`;

const School = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    &:last-of-type {
        margin-top: 10px;
    }

    @media screen and (max-width: 991px){
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        line-height: 2.2em;
    }
`;

const Name = styled.p`
    font-size: 1.2rem;
    margin-bottom: 0;
    color: #eaeaea;
    cursor: pointer;

    &: hover {
        color: #5f27cd;
    }
`;

const GradePoints = styled.p`
    font-size: 1rem;   
    line-height:2em;
    color: #b1b1b1;
`;